import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL + "/api" || 'http://localhost:5000';
const TWILIO_NUMBER = process.env.REACT_APP_TWILIO_NUMBER;
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add auth token to requests if available
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export const login = async (username, password) => {
    try {
        const response = await api.post('/auth/login', { username, password });
        return response.data;
    } catch (error) {
        throw error.response?.data?.error || 'Login failed';
    }
};

export const getTwilioNumberFromAPI = async () => {
    return TWILIO_NUMBER;
};

export const getMessages = async () => {
    try {
        const response = await api.get('/messages');
        return response.data;
    } catch (error) {
        throw error.response?.data?.error || 'Failed to fetch messages';
    }
};

export const getUnreadMessages = async () => {
    try {
        const response = await api.get('/messages/unread');
        return response.data;
    } catch (error) {
        throw error.response?.data?.error || 'Failed to fetch unread messages';
    }
};

export const markAsRead = async (messageId) => {
    try {
        const response = await api.post(`/messages/${messageId}/read`);
        return response.data;
    } catch (error) {
        throw error.response?.data?.error || 'Failed to mark message as read';
    }
};

export const sendReply = async (from, to, body, refId) => {
    try {
        const response = await api.post('/messages/reply', { from, to, body, refId });
        return response.data;
    } catch (error) {
        throw error.response?.data?.error || 'Failed to send reply';
    }
};

export default api;